import { IWorkbookDetailInfo } from '../../../../ts/models/IWorkbookInfo';
import { Workbooks } from '../../../../content/resources/Workbooks';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export function fetchWorkbookById(workbookId: string): Promise<IWorkbookDetailInfo> {
  return Workbooks.getById(workbookId);
}

export function getExtractDraftId(workbookId: string): Promise<IResult> {
  return Workbooks.getExtractDraftId(workbookId);
}
